import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthResult } from '../models/auth-result.model';
import { SDKErrorResponse } from '../models/sdk-error-response.model';
import { SDKResponse } from '../models/sdk-response.model';
import { Simulacao } from '../models/simulacao.model';
import { AesEncryptDecryptService } from './aes-encrypt-decrypt.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  private loadingSource$ = new BehaviorSubject<boolean | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.loading))));
  private accessTokenSource$ = new BehaviorSubject<string | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.accessToken))));
  private authResult$ = new BehaviorSubject<AuthResult | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.authResult))));
  private saltResult$ = new BehaviorSubject<string | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.saltResult))));
  private simulacaoSource$ = new BehaviorSubject<Simulacao | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.simulacao))));
  private originSource$ = new BehaviorSubject<string | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.origin))));
  private SDKResponseSource$ = new BehaviorSubject<SDKResponse | SDKErrorResponse | null>(JSON.parse(this.encrypt.decrypt(sessionStorage.getItem(environment.localpoints.response_result))));

  getLoading = this.loadingSource$.asObservable();
  getAccessToken = this.accessTokenSource$.asObservable();
  getAuthResult = this.authResult$.asObservable();
  getSaltResult = this.saltResult$.asObservable();
  getSimulacao = this.simulacaoSource$.asObservable();
  getOrigin = this.originSource$.asObservable();
  getSDKResponse = this.SDKResponseSource$.asObservable();

  constructor(private encrypt: AesEncryptDecryptService) { }

  setLoading(state: boolean):Promise<any> {
    return new  Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.loading, this.encrypt.encrypt(JSON.stringify(state)));
        this.loadingSource$.next(state);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    })
  }

  setAccessToken(accessToken: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.accessToken, this.encrypt.encrypt(accessToken));
        this.accessTokenSource$.next(accessToken);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    })
  }

  setAuthResult(authResult: AuthResult): Promise<any> {
    // console.log('auth result => ', authResult);
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.authResult, this.encrypt.encrypt(JSON.stringify(authResult)));
        this.authResult$.next(authResult);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    });
  }

  setSaltResult(salt: string) :Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.saltResult, this.encrypt.encrypt(JSON.stringify(salt)));
        this.saltResult$.next(salt);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    });
  }

  setSimulacao(simulacao: Simulacao): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.simulacao, this.encrypt.encrypt(JSON.stringify(simulacao)));
        this.simulacaoSource$.next(simulacao);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    });
  }

  setOrigin(origin: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.origin, this.encrypt.encrypt(JSON.stringify(origin)));
        this.originSource$.next(origin);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    });
  }

  setResponseResult(response: SDKResponse | SDKErrorResponse): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(environment.localpoints.response_result, this.encrypt.encrypt(JSON.stringify(response)));
        this.SDKResponseSource$.next(response);
        resolve(true);
      } catch (error) {
        reject(false);
      }
    });
  }
}
